import { NgModule, ModuleWithProviders } from '@angular/core';
import { UserService } from '../commonservices/user.service';
import { AppService } from '../commonservices/app.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        UserService,
        AppService
    ],
})
export class CommonServicesModule {    
}

